import { getConciliationBalanceRows, getConciliationBalanceAmount, getRemovedConciliationAdjustment } from '../../utils/conciliationBalanceRows'
import ConciliationAdjustmentAmount from '../ui/ConciliationAdjustmentAmount'
import { getConciliationAdjustmentDisplay } from '../../utils/conciliationAdjustmentDisplay'
import { applyConciliationAdjustment } from '../../utils/conciliationAdjustment'
import { getConciliationAccountDisplayNumber } from '../../utils/conciliationAccountDisplay'
import { getConciliationRenderKey, mergeConciliationRows } from '../../utils/conciliationRows'
import { allocateConciliationMovements } from '../../utils/conciliationAllocation'
import AssignedAmountInput from '../modalDialogEditarMovBancario/AssignedAmountInput'
import { getVinculacionAvailableAmount } from '../../utils/vinculacionAmounts'
import { buildBankConciliationPayload, routeEditedConciliationAmounts } from '../modalDialogEditarMovBancario/bankConciliationPayload'
import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import GlobalContext from '../../../context/global-context'
import { OrganizationAPI } from '../../../api/organization.api'
import { BusinessAPI } from '../../../api/business.api'
import { useSummaryMovementsOverrides } from '../../../pages/useAdministracion.hooks'
import ListEditVincular from './ListEditVincular'
import { Box } from '@mui/material'
import { Button } from '../ui'
import LoaderMain from '../../../assets/svgIcons/loaderMain.json'
import Lottie from 'lottie-react'
import { formatCurrency, formatDate, formatRut } from '../../utils/formatter'
import isologo_SII from '../../../assets/isologo_SII.png'
import ResizableModal from '../ui/ResizableModal'
import ConfirmConciliationModal from '../ui/ConfirmConciliationModal'
import {
  getPreviousYearConciliationRowKey,
  isPreviousYearConciliationLinkage,
  normalizeConciliationPayload
} from '../../utils/normalizeConciliationLinkage'

const ENABLE_DIN_ANTICIPO = true
import { bankIcons } from '../views/dashboard/Administracion/bancos/data'
import translations from '../ui/traslation/traslationAdministracion.json'
import imgDefaultBank from '../../../assets/iconos/iconCasa.png'

/**
 * @typedef {Object} idsYear
 * @property {number[]} ids
 */

/**
 * @typedef {Object} montoYear
 * @property {number} [year]
 * @property {number} [monto]
 */

/**
 * @typedef {Object} fourInOneDto
 * @property {idsYear} datoBanco
 * @property {idsYear} datoBoleta
 * @property {montoYear} datoCaja
 * @property {montoYear} datoCajaLastYear
 * @property {boolean} instrucciones
 */

const ModalEditConciliar = ({ open, setOpen, idLibro, setSwitchGetData, type, status, nombreFolio }) => {
  const { ui, currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const businessAPI = useMemo(() => new BusinessAPI(), [])
  const setMovementOverride = useSummaryMovementsOverrides(state => state.setOverride)
  const [data, setData] = useState({})
  //const bankAPI = new BankAPI()
  const [selectedIds, setSelectedIds] = useState({
    banco: [],
    tc: [],
    caja: [],
    gestion: [],
    anticipo: []
  })
  const [unselectedIds, setUnselectedIds] = useState({
    banco: [],
    tc: [],
    caja: [],
    gestion: [],
    anticipo: []
  })
  const [, setInitialSelectedIds] = useState([])
  const [loading, setLoading] = useState(false)
  const [reloadData, setReloadData] = useState(false)
  const [selectedBank, setSelectedBank] = useState('')
  const [origenSeleccionado, setOrigenSeleccionado] = useState([])
  const [selectedDataByOrigen, setSelectedDataByOrigen] = useState({})
  const [editedAmounts, setEditedAmounts] = useState({})
  useEffect(() => { setEditedAmounts({}) }, [open, idLibro, currentBusiness?.id])
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({})
  const [showConfirmPopup, setShowConfirmPopup] = useState(false)
  const [popupMessage, setPopupMessage] = useState('')
  const [isInteracting, setIsInteracting] = useState(false)
  const [currentLibroId, setCurrentLibroId] = useState(idLibro)
  const libroIdRef = useRef(idLibro)
  const [processMessage, setProcessMessage] = useState('')
  const [conciliarConAnticipo, setConciliarConAnticipo] = useState(false)
  const showGlobalLoader = message =>
    ui.setLoader({ visible: true, ...(message ? { message } : {}) })
  const hideGlobalLoader = () => ui.setLoader({ visible: false })
  const normalizeDocumentLabel = value =>
    String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

  const isBoletaDocument = item => {
    const nombreFolio = normalizeDocumentLabel(item?.nombreFolio)
    const nombreCuenta = normalizeDocumentLabel(item?.nombreCuenta)
    const nombreDocumento = normalizeDocumentLabel(item?.nombreCodigoDocumento)

    return (
      nombreFolio === 'boleta' ||
      nombreDocumento.includes('boleta') ||
      nombreCuenta.includes('boleta')
    )
  }
  const getBoletaAmount = item => {
    const candidates = [item?.montoNetoLiquido, item?.montoNeto, item?.montoTotal]

    for (const value of candidates) {
      const numeric = Number(value)
      if (Number.isFinite(numeric) && numeric !== 0) return numeric
    }

    return Number(item?.montoNetoLiquido ?? item?.montoNeto ?? item?.montoTotal ?? 0) || 0
  }
  const getMainDocumentAmount = item =>
    isBoletaDocument(item) ? getBoletaAmount(item) : Number(item?.montoTotal ?? 0) || 0

  const isDinDocument = item => {
    const nombreDocumento = normalizeDocumentLabel(item?.nombreCodigoDocumento)
    return nombreDocumento === 'declaracion de ingreso (din)'
  }

  const toArr = value => (Array.isArray(value) ? value : [])
  const pruneSelectedDataByIds = ids => {
    if (!ids || ids.length === 0) return
    const removeSet = new Set(ids.map(id => Number(id)))
    setSelectedDataByOrigen(prev => {
      const next = {}
      Object.entries(prev).forEach(([origin, rows]) => {
        next[origin] = toArr(rows).filter(row => {
          const real = getRealConciliationId(row) ?? toNumId(row?.id)
          return !removeSet.has(real)
        })
      })
      return next
    })
    setSelectedIds(prev => {
      const next = {}
      Object.entries(prev).forEach(([origin, idsArr]) => {
        next[origin] = toArr(idsArr).filter(id => !removeSet.has(Number(id)))
      })
      return next
    })
  }

  const updateLibroId = newId => {
    if (!newId) return
    libroIdRef.current = newId
    setCurrentLibroId(newId)
  }

  const getInitialMontoEditable = row => {
    if (!row) return 0
    if (typeof row?._initialMontoEditable === 'number') return row._initialMontoEditable
    if (isBoletaDocument(row)) return getBoletaAmount(row)
    const fallback =
      row?.montoEditable ??
      row?.montoRelacionado ??
      row?.montoAbono ??
      row?.montoCargo ??
      row?.montoTotal ??
      row?.debe ??
      row?.haber ??
      0
    const numeric = Number(fallback)
    return Number.isFinite(numeric) ? numeric : 0
  }

  const ensureRowMetadata = (row, origen) => {
    if (!row) return row
    const resolvedOrigin = row?._origen || origen
    const hasInitial = typeof row?._initialMontoEditable === 'number'
    const initialValue = hasInitial ? row._initialMontoEditable : getInitialMontoEditable(row)
    return {
      ...row,
      _origen: resolvedOrigin,
      _initialMontoEditable: initialValue
    }
  }

  const getRowId = item => {
    if (!item) return undefined
    const gestionKey = getPreviousYearConciliationRowKey(item)
    if (gestionKey != null) return gestionKey
    if (item.tipo === 'caja')
      return `custom-caja-${item.id || item.nombreCuentaBanco || 'principal'}`
    if (item.tipo === 'gestion')
      return `custom-gestion-${item.id || item.nombreCuentaBanco || 'principal'}`
    return [
      item?.idPrincipal,
      item?.id_principal,
      item?.egreso?.idPrincipal,
      item?.ingreso?.idPrincipal,
      item?.linkage?.idPrincipal,
      item?.id
    ].find(value => value != null && String(value).trim() !== '' && Number(value) !== 0)
  }

  const toNumId = rid => {
    const n = Number(rid)
    return Number.isFinite(n) ? n : null
  }

  const getRealConciliationId = row => {
    if (!row) return null
    const candidates = [
      row?.idPrincipal,
      row?.id_principal,
      row?.linkage?.idPrincipal,
      row?.egreso?.idPrincipal,
      row?.ingreso?.idPrincipal,
      row?.id
    ]
    for (const value of candidates) {
      const numeric = toNumId(value)
      if (numeric !== null && numeric !== 0) return numeric
      if (typeof value === 'string') {
        const match = value.match(/\d+/)
        if (match) return Number(match[0])
      }
    }
    return null
  }
  const firstValid = (...values) =>
    values.find(v => v != null && Number(v) !== 0) ?? 0

  const selectedRowsData = Object.entries(selectedDataByOrigen)
    .flatMap(([origen, rows]) =>
      (rows ?? []).map(r => ({
        ...r,
        _origen: origen,
        montoEditable: isBoletaDocument(r)
          ? getBoletaAmount(r)
          : firstValid(
              r.monto,
              r.montoEditable,
              r.montoRelacionado,
              r.montoAbono,
              r.montoCargo,
              r.montoTotal,
              r.debe,
              r.haber
            )
      }))
    )

  const uniqueSelectedRowsData = useMemo(() => {
    const seen = new Set()
    return selectedRowsData.filter((row) => {
      const id = getRowId(row)
      if (!id || seen.has(id)) return false
      seen.add(id)
      return true
    })
  }, [selectedRowsData])

  const toNumericOrNull = value => {
    const num = Number(value)
    return Number.isFinite(num) ? num : null
  }

  const getDisplayDescription = item => {
    const baseDescription = item?.descripcion || item?.razonSocial || item?.glosa || ''
    const normalizedDescription = String(baseDescription).trim().toLowerCase()

    if (normalizedDescription.startsWith('pago comprobante')) {
      if (item?.tipoMovimiento === 'abono') return 'Cobro masivo vinculacion'
      if (item?.tipoMovimiento === 'cargo') return 'Pago masivo vinculacion'
    }

    return baseDescription
  }

const getBancoAmount = item => {
  const isBoleta = isBoletaDocument(item)
  if (isBoleta) {
    return getBoletaAmount(item)
  }

  const candidates = [
    item?.monto,
    !isBoleta ? item?.montoRelacionado : null,
    !isBoleta ? item?.montoTotal : null,
    item?.montoCargo,
    item?.haber,
    item?.montoAbono,
    item?.debe
  ]

  for (const c of candidates) {
    const n = toNumericOrNull(c)
    if (n !== null && n !== 0) return n
  }

  // --- 3) Fallback ---
  const fallback = toNumericOrNull(
    item?.montoRelacionado ?? item?.montoTotal ?? item?.monto ?? item?.montoEditable ?? 0
  )
  return fallback ?? 0
}

  const getItemAmountForSum = (item, useEdits = true) => {
    if (useEdits && editedAmounts[getRowId(item)] != null) return editedAmounts[getRowId(item)]
    if (item?.customRow !== true && item?.monto != null) {
      return Number(item.monto) || 0
    }
    if (item?.montoEditable != null) {
      return Number(item.montoEditable) || 0
    }
    const isCajaOGestion =
      item?.tipo === 'caja' ||
      item?.tipo === 'gestion' ||
      item?.nombreCuentaBanco?.toLowerCase?.().includes('caja') ||
      item?.nombreCuentaBanco?.toLowerCase?.().includes('gestion')
    if (isCajaOGestion) {
      return Number(
        item?.montoRelacionado ?? item?.montoAbono ?? item?.montoCargo ?? item?.montoTotal ?? item?.monto ?? item?.debe ?? item?.cargo ?? 0
      )
    }
    return getBancoAmount(item)
  }

  const getComparableMonto = row =>
    isBoletaDocument(row)
      ? getBoletaAmount(row)
      : Number(
          row?.montoEditable ??
            row?.montoRelacionado ??
            row?.montoAbono ??
            row?.montoCargo ??
            row?.montoTotal ??
            row?.monto ??
            row?.debe ??
            row?.haber ??
            0
        ) || 0

  const collectChangedRealIds = rows => {
    const ids = []
    rows?.forEach(row => {
      if (!row) return
      const realId = getRealConciliationId(row)
      if (!realId) return
      const initialValue = getInitialMontoEditable(row)
      const currentValue = getComparableMonto(row)
      if (Number(initialValue) !== Number(currentValue)) {
        ids.push(realId)
      }
    })
    return Array.from(new Set(ids))
  }

  const normalizeOrigen = value => (value || '').toString().toLowerCase()

  const getRowsForOrigen = (origen, fallback = []) => {
    const rows = toArr(selectedDataByOrigen[origen]) ?? toArr(fallback)
    const target = normalizeOrigen(origen)
    return rows.filter(row => {
      const rowOrigin = normalizeOrigen(row?._origen || row?.tipo)
      if (target === 'banco') {
        return rowOrigin === '' || rowOrigin === 'banco'
      }
      if (target === 'tc') {
        return rowOrigin === 'tc'
      }
      return rowOrigin === target
    })
  }

  const rowsBase = useMemo(
    () => mergeConciliationRows(data?.linkage ?? [], uniqueSelectedRowsData),
    [uniqueSelectedRowsData, data]
  )

  const isRowUnselected = item => {
    const origin = isPreviousYearConciliationLinkage(item)
      ? 'gestion'
      : item?._origen || item?.tipo
    const originUnselectedIds = origin
      ? toArr(unselectedIds?.[origin])
      : Object.values(unselectedIds || {}).flat()
    const ids = [
      item?.id,
      item?.idPrincipal,
      item?.idOrigin,
      item?.realId,
      getRowId(item),
      getRealConciliationId(item)
    ]
      .filter(value => value != null)
      .map(String)

    return originUnselectedIds.some(id => ids.includes(String(id)))
  }

  const rowsToShow = useMemo(() => {
    return rowsBase.filter(item => !isRowUnselected(item))
  }, [rowsBase, unselectedIds])

  const selectedRowsToSum = useMemo(() => {
    return rowsBase.filter(item => !isRowUnselected(item))
  }, [rowsBase, unselectedIds])

  useEffect(() => {
    if (open) {
      //
    }
  }, [open, rowsToShow])
  const handleCurrentData = origen => rows => {
    const normalized = (rows ?? []).map(row => ensureRowMetadata(row, origen))
    setSelectedDataByOrigen(prev => ({
      ...prev,
      [origen]: normalized
    }))
  }

  const initializeGestionFromLinkage = payload => {
    const gestionRows = toArr(payload?.linkage)
      .filter(isPreviousYearConciliationLinkage)
      .map(item => ensureRowMetadata(item, 'gestion'))

    if (gestionRows.length === 0) return

    const gestionIds = gestionRows.map(getRowId).filter(id => id != null)

    setSelectedDataByOrigen(prev => ({ ...prev, gestion: gestionRows }))
    setSelectedIds(prev => ({ ...prev, gestion: gestionIds }))
    setSelectedCheckboxes(prev => {
      const next = { ...prev }
      gestionIds.forEach(id => {
        next[String(id)] = true
      })
      return next
    })
    setUnselectedIds(prev => ({ ...prev, gestion: [] }))
    setOrigenSeleccionado(prev =>
      prev.includes('gestion') ? prev : [...prev, 'gestion']
    )
  }

  const handleClose = () => {
    setOpen(false)
  }

  const refreshLibroState = async () => {
    try {
      const libroIdToUse = resolveLibroId()
      const response = await organizationAPI.getDataLibroContable(
        currentBusiness.id,
        libroIdToUse,
        type
      )
      const payload = normalizeConciliationPayload(response?.data ?? {})
      setData(payload)
      initializeGestionFromLinkage(payload)
      if (payload?.idPrincipal) {
        updateLibroId(payload.idPrincipal)
      }
      return payload
    } catch (error) {
      console.error(error)
      return null
    }
  }

  const functionGetDataLibroContable = async () => {
    try {
      setLoading(true)
      const libroIdToUse = resolveLibroId() ?? idLibro
      if (!libroIdToUse) {
        return
      }
      const response = await organizationAPI.getDataLibroContable(
        currentBusiness.id,
        libroIdToUse,
        type
      )
      const payload = normalizeConciliationPayload(response?.data ?? {})
      setData(payload)
      initializeGestionFromLinkage(payload)
      if (payload?.idPrincipal) {
        updateLibroId(payload.idPrincipal)
      }
    } catch (error) {
      console.error(error)
    } finally {
      //ui.setLoader({ visible: false})
      setLoading(false)
    }
  }

  useEffect(() => {
    if (open) {
      functionGetDataLibroContable()
      setData(prevData => ({
        ...prevData
      }))
    }
  }, [reloadData])

  useEffect(() => {
    if (idLibro) {
      libroIdRef.current = idLibro
      setCurrentLibroId(idLibro)
    }
    setConciliarConAnticipo(false)
    setIsInteracting(false)
  }, [idLibro])

  const resolveLibroId = () => data?.idPrincipal ?? libroIdRef.current ?? currentLibroId ?? idLibro

  const handleDesvincular = async ids => {
    const numericIds = Array.from(
      new Set(toArr(ids).map(toNumId).filter(id => id !== null))
    )
    if (numericIds.length === 0) return
    const payload = { ids: numericIds }
    try {
      showGlobalLoader()
      const response = await organizationAPI.postDesvincular(
        {
          businessId: currentBusiness.id,
          idLibro: resolveLibroId()
        },
        payload
      )
      pruneSelectedDataByIds(numericIds)
      const payloadData = normalizeConciliationPayload(response?.data ?? response)
      if (payloadData) {
        setData(payloadData)
        if (payloadData?.idPrincipal) updateLibroId(payloadData.idPrincipal)
      }
    } catch (error) {
      console.error(error)
    } finally {
      hideGlobalLoader()
    }
  }
  const handleDesvincularBoletas = async ids => {
    if (ids.length === 0) return
    const payload = { ids: ids.map(Number) }
    try {
      ui.setLoader({ visible: true })
      const response = await organizationAPI.postBoleta(
        {
          businessId: Number(currentBusiness.id),
          idLibro: resolveLibroId()
        },
        payload,
        true
      )
      pruneSelectedDataByIds(ids)
      const payloadData = response?.data ?? response
      if (payloadData?.idPrincipal) {
        updateLibroId(payloadData.idPrincipal)
      }
    } catch (error) {
      console.error(error)
    } finally {
      ui.setLoader({ visible: false })
    }
  }

  const mapRowsToIds = rows =>
    Array.from(
      new Set(
        rows
          .map(row => getRealConciliationId(row) ?? toNumId(row.id))
          .filter(id => id != null)
      )
    )

  const unwrapApiResponse = response => (response?.data ?? response)

  const extractLibroIdFromPayload = payload => {
    if (!payload) return null
    if (Array.isArray(payload)) {
      for (const entry of payload) {
        const nested = extractLibroIdFromPayload(entry)
        if (nested) return nested
      }
      return null
    }
    if (typeof payload !== 'object') return null
    const candidates = [payload?.idPrincipal, payload?.idLibro, payload?.id, payload?.libroId]
    for (const value of candidates) {
      const numeric = Number(value)
      if (Number.isFinite(numeric) && numeric > 0) return numeric
    }
    if (payload?.linkage) {
      const nested = extractLibroIdFromPayload(payload.linkage)
      if (nested) return nested
    }
    if (payload?.data) {
      const nested = extractLibroIdFromPayload(payload.data)
      if (nested) return nested
    }
    return null
  }

  const syncLibroIdFromResponse = async response => {
    const payloadData = unwrapApiResponse(response)
    const newId = extractLibroIdFromPayload(payloadData)
    if (newId) {
      updateLibroId(newId)
    } else {
      await refreshLibroState()
    }
    return payloadData
  }

  const postFourInOneSegment = async (label, dto) => {
    if (!dto) return null
    const libroPayload = {
      businessId: Number(currentBusiness.id),
      idLibro: resolveLibroId()
    }
    if (!libroPayload.idLibro) {
      console.warn(`[Conciliar] No hay idLibro para ${label}, se omite envío`)
      return null
    }
    const response = await organizationAPI.postForInOne(libroPayload, dto)
    await syncLibroIdFromResponse(response)
    return response
  }

  const handleFourInOne = async (ajusteAEnviar = false) => {
    try {
      showGlobalLoader('Desconciliando movimientos…')
      setProcessMessage('Desconciliando movimientos…')

      const rowsCaja = getRowsForOrigen('caja', selectedDataByOrigen['caja'])
      const gestionUnselectedSet = new Set(
        toArr(unselectedIds.gestion).map(id => String(id))
      )
      const rowsGestion = getRowsForOrigen('gestion', selectedDataByOrigen['gestion'])
        .filter(row => {
          const rowIds = [
            getRowId(row),
            getRealConciliationId(row),
            row?.id,
            row?.idPrincipal,
            row?.idOrigin
          ]
            .filter(id => id != null)
            .map(String)
          return !rowIds.some(id => gestionUnselectedSet.has(id))
        })

      const changedCajaIds = collectChangedRealIds(rowsCaja)
      const changedGestionIds = collectChangedRealIds(rowsGestion)

      const bancoRows = getRowsForOrigen('banco', selectedDataByOrigen['banco'])
      const idsBanco = mapRowsToIds(bancoRows)
      const bancoIdsSet = new Set(idsBanco.map(Number))
      const tcRows = getRowsForOrigen('tc', selectedDataByOrigen['tc'])
      const anticipoRows = ENABLE_DIN_ANTICIPO
        ? getRowsForOrigen('anticipo', selectedDataByOrigen['anticipo'])
        : []
      const idsBoletas = mapRowsToIds(tcRows)
      const idsAnticipos = mapRowsToIds(anticipoRows)
      const linkedIdsSet = new Set(
        toArr(data?.linkage)
          .map(item => getRealConciliationId(item) ?? toNumId(getRowId(item)))
          .filter(id => id != null)
          .map(Number)
      )
      const idsAnticiposNuevos = idsAnticipos.filter(
        id => !linkedIdsSet.has(Number(id))
      )

      const manualCajaRows = rowsCaja.filter(row => typeof row?._manualCajaMonto === 'number')
      const manualBancoToUnlink = Array.from(
        new Set(
          manualCajaRows
            .map(row => {
              const explicitManualId = toNumId(row?._manualLinkedId)
              if (explicitManualId) return explicitManualId
              const realId = getRealConciliationId(row)
              if (realId) return realId
              return null
            })
            .filter(id => id != null && bancoIdsSet.has(Number(id)))
        )
      )
      const manualBancoToUnlinkSet = new Set(manualBancoToUnlink.map(id => Number(id)))

      if (manualBancoToUnlink.length > 0) {
        //
      }

      const bancoToUnlink = Array.from(
        new Set([
          ...(unselectedIds.banco ?? []),
          ...manualBancoToUnlink
        ])
      ).map(toNumId).filter(id => id !== null)
      const tcToUnlink = Array.from(
        new Set(unselectedIds.tc ?? [])
      ).map(toNumId).filter(id => id !== null)
      const anticipoToUnlink = Array.from(
        new Set(ENABLE_DIN_ANTICIPO ? unselectedIds.anticipo ?? [] : [])
      ).map(toNumId).filter(id => id !== null)
      const cajaToUnlink = Array.from(
        new Set([...(unselectedIds.caja ?? []), ...changedCajaIds])
      ).map(toNumId).filter(id => id !== null)
      const genericRelatedIds = toArr(data?.linkage)
        .filter(item => {
          if (Number(item?.idPrincipal) !== 0) return false
          const itemIds = [item?.id, item?.idOrigin].filter(id => id != null).map(String)
          return itemIds.some(id => gestionUnselectedSet.has(id))
        })
        .flatMap(item => [item?.id, item?.idOrigin])
        .filter(id => id != null)
      const gestionToUnlink = Array.from(
        new Set([
          ...(unselectedIds.gestion ?? []),
          ...genericRelatedIds,
          ...changedGestionIds
        ])
      ).map(toNumId).filter(id => id !== null)
      const genericToUnlink = Array.from(
        new Set([
          ...bancoToUnlink,
          ...anticipoToUnlink,
          ...cajaToUnlink,
          ...gestionToUnlink
        ])
      )

      let hasDesvinculado = false

      if (genericToUnlink.length > 0) {
        await handleDesvincular(genericToUnlink)
        hasDesvinculado = true
      }
      if (tcToUnlink.length > 0) {
        await handleDesvincularBoletas(tcToUnlink)
        hasDesvinculado = true
      }

      if (hasDesvinculado) {
        await refreshLibroState()
      }

      const hayAlgoParaVincular =
        (selectedDataByOrigen.vinculacion?.length ?? 0) > 0 ||
        bancoRows.length > 0 ||
        tcRows.length > 0 ||
        anticipoRows.length > 0 ||
        rowsCaja.length > 0 ||
        rowsGestion.length > 0

      if (
        (genericToUnlink.length > 0 || tcToUnlink.length > 0) &&
        !hayAlgoParaVincular
      ) {
        setProcessMessage('Refrescando movimientos…')
        showGlobalLoader('Refrescando movimientos…')
        await functionGetDataLibroContable()
        try {
        const movimientoId = data?.id ?? resolveLibroId()
        if (movimientoId) {
          const response = await businessAPI.getSummaryMovementById(currentBusiness.id, movimientoId)
          const movement = response?.data ?? response
          setMovementOverride(movement)
        }
        } catch (error) {
          console.error('[Conciliar] Error al consultar movimiento puntual (desvincular)', error)
        }
        setProcessMessage('')
        hideGlobalLoader()
        setSwitchGetData?.(true)
        return
      }

      setProcessMessage('Conciliando movimientos…')
      showGlobalLoader('Conciliando movimientos…')

      // --- Vinculación / actualización ---
      const dto = {
        datoBanco: { ids: [] },
        datoBoleta: { ids: [] },
        datoCaja: {},
        datoCajaLastYear: {},
        instrucciones: []
      }

      let bancoFlag = false
      let boletaFlag = false
      let cajaFlag = false
      let gestionFlag = false

      const effectiveBancoIds = Array.from(
        new Set(idsBanco.filter(id => !manualBancoToUnlinkSet.has(Number(id)) &&
          (ajusteAEnviar || bancoRows.some(row => {
            if (Number(getRealConciliationId(row)) !== Number(id)) return false
            return editedAmounts[getRowId(row)] != null || findLinkedRow(row) || allocation.allocations.some(movement =>
              movement.key === getConciliationRenderKey(row) && movement.assigned > 0)
          }))))
      )
      const effectiveBoletaIds = Array.from(new Set(idsBoletas.filter(id =>
        ajusteAEnviar || tcRows.some(row => Number(getRealConciliationId(row)) === Number(id) &&
          (editedAmounts[getRowId(row)] != null || findLinkedRow(row) || allocation.allocations.some(movement =>
            movement.key === getConciliationRenderKey(row) && movement.assigned > 0))))))
      const idsComprasDin = Array.from(
        new Set(
          [data?.idPrincipal ?? resolveLibroId()]
            .map(Number)
            .filter(id => Number.isFinite(id) && id > 0)
        )
      )

      // Banco
      if (effectiveBancoIds.length > 0) {
        dto.datoBanco = buildBankConciliationPayload(effectiveBancoIds, bancoRows.filter(row =>
          effectiveBancoIds.includes(getRealConciliationId(row))).map(row => ({
          ...row, id: getRowId(row), idPrincipal: getRealConciliationId(row)
        })), editedAmounts)
        bancoFlag = true
      }

      // Boletas (tc)
      if (effectiveBoletaIds.length > 0) {
        dto.datoBoleta = buildBankConciliationPayload(effectiveBoletaIds, tcRows.filter(row =>
          effectiveBoletaIds.includes(getRealConciliationId(row))).map(row => ({
          ...row, id: getRowId(row), idPrincipal: getRealConciliationId(row)
        })), editedAmounts)
        boletaFlag = true
      }

      const routedAmounts = routeEditedConciliationAmounts(dto.datoBanco, dto.datoBoleta)
      dto.datoBanco = routedAmounts.datoBanco
      dto.datoBoleta = routedAmounts.datoBoleta
      bancoFlag = routedAmounts.instrucciones[0]
      boletaFlag = routedAmounts.instrucciones[1]

      const vinculacionIds = (selectedDataByOrigen.vinculacion ?? [])
        .map(movement => Number(movement.idPrincipal ?? movement.id))
        .filter(id => Number.isFinite(id) && id > 0)
      if (vinculacionIds.length > 0) {
        if (Array.isArray(dto.datoBanco)) {
          await postFourInOneSegment('Banco', {
            ...dto, datoBoleta: { ids: [] }, datoCaja: {}, datoCajaLastYear: {},
            instrucciones: [true, false, false, false]
          })
          dto.datoBanco = { ids: [] }
        }
        dto.datoBanco = {
          ...dto.datoBanco,
          ids: [...new Set([...(dto.datoBanco.ids ?? []), ...vinculacionIds])]
        }
        bancoFlag = true
      }

      // --- Calcular montos ---
      const calcularMontoPorTipo = (rows, tipo) => {
        const filtro =
          tipo === 'caja'
            ? item => item.nombreCuentaBanco?.toLowerCase().includes('caja') || item.tipo === 'caja'
            : item => item.customRow === true || item.tipo === 'gestion'

        const seleccion = rows.filter(filtro)
        return seleccion.reduce(
          (acc, item) => acc + (ajusteAEnviar
            ? (item.montoEditable ?? item.montoAbono ?? item.montoCargo ?? 0)
            : allocation.allocations.find(row => row.key === getConciliationRenderKey(item))?.assigned ??
              getItemAmountForSum(findLinkedRow(item) ?? item)),
          0
        )
      }

      // Caja
      if (rowsCaja.length > 0) {
        const cajaMontoActual = calcularMontoPorTipo(rowsCaja, 'caja')
        const cajaRealIds = rowsCaja
          .map(item => getRealConciliationId(item))
          .filter(id => id != null)
        const tieneCajaCustom = rowsCaja.some(item => getRealConciliationId(item) == null)
        const overlapCajaBanco =
          !tieneCajaCustom && cajaRealIds.some(id => idsBanco.includes(id))
        const cajaModificada = (changedCajaIds ?? []).length > 0
        const manualCajaValues = rowsCaja
          .map(item => (typeof item?._manualCajaMonto === 'number' ? Number(item._manualCajaMonto) : null))
          .filter(value => typeof value === 'number' && Number.isFinite(value))
        const manualCajaMonto =
          manualCajaValues.length > 0
            ? manualCajaValues.reduce((acc, value) => acc + value, 0)
            : null
        const shouldSendCaja =
          manualCajaMonto != null || tieneCajaCustom || !overlapCajaBanco || cajaModificada

        if (shouldSendCaja) {
          const montoCajaFinal = ajusteAEnviar && manualCajaMonto != null ? manualCajaMonto : cajaMontoActual
          dto.datoCaja = { monto: montoCajaFinal }
          if (manualCajaMonto != null) {
            //
          }
          cajaFlag = true
        } else {
         //
        }
      }

      // Gestión
      if (rowsGestion.length > 0) {
        dto.datoCajaLastYear = {
          year: new Date().getFullYear() - 1,
          monto: calcularMontoPorTipo(rowsGestion, 'gestion')
        }
        gestionFlag = true
      }

      // --- NUEVO: instrucciones ---
      dto.instrucciones = [bancoFlag, boletaFlag, cajaFlag, gestionFlag]

      if (idsAnticiposNuevos.length > 0 && idsComprasDin.length > 0) {
        await Promise.all(
          idsAnticiposNuevos.map(idAnticipo =>
            organizationAPI.postListaVincular(
              {
                businessId: Number(currentBusiness.id),
                idLibro: Number(idAnticipo),
                din: true
              },
              { ids: idsComprasDin }
            )
          )
        )
      }

      if (ajusteAEnviar) {
        await postFourInOneSegment('Ajuste', applyConciliationAdjustment(dto, ajusteAEnviar))
      } else if (bancoFlag || boletaFlag) {
        const bancoDto = {
          datoBanco: bancoFlag ? dto.datoBanco : { ids: [] },
          datoBoleta: boletaFlag ? dto.datoBoleta : { ids: [] },
          datoCaja: {},
          datoCajaLastYear: {},
          instrucciones: [bancoFlag, boletaFlag, false, false]
        }
        await postFourInOneSegment('Banco/TC', bancoDto)
      }

      if (!ajusteAEnviar && (cajaFlag || gestionFlag)) {
        const cajaDto = {
          datoBanco: { ids: [] },
          datoBoleta: { ids: [] },
          datoCaja: cajaFlag ? { ...dto.datoCaja } : {},
          datoCajaLastYear: gestionFlag ? { ...dto.datoCajaLastYear } : {},
          instrucciones: [false, false, cajaFlag, gestionFlag]
        }
        await postFourInOneSegment('Caja/Gestión', cajaDto)
      }

      setProcessMessage('Refrescando movimientos…')
      showGlobalLoader('Refrescando movimientos…')
      await functionGetDataLibroContable()
      try {
        const movimientoId = data?.id ?? resolveLibroId()
        if (movimientoId) {
          const response = await businessAPI.getSummaryMovementById(currentBusiness.id, movimientoId)
          const movement = response?.data ?? response
          setMovementOverride(movement)
        }
      } catch (error) {
        console.error('[Conciliar] Error al consultar movimiento puntual', error)
      }
      setSwitchGetData?.(true)

      // Mantener el loader visible unos segundos antes de cerrar el modal
      await new Promise(resolve => setTimeout(resolve, 2000))
      handleClose()
    } catch (error) {
      console.error(error)
    } finally {
      setProcessMessage('')
      hideGlobalLoader()
        handleClose()
    }
  }

  const esDin = ENABLE_DIN_ANTICIPO && isDinDocument(data)
  const montoIvaDin = Number(data.montoIva ?? 0) || 0
  const montoFilter = esDin && conciliarConAnticipo ? montoIvaDin : data.montoTotal
  const esBoleta =
    normalizeDocumentLabel(nombreFolio) === 'boleta' ||
    type === 'honorario' ||
    isBoletaDocument(data)
  const montoBaseDocumento = esDin && conciliarConAnticipo
    ? montoIvaDin
    : esBoleta
      ? getBoletaAmount(data)
      : getMainDocumentAmount(data)
  const tituloDocumento = esBoleta
    ? 'Boletas de Honorarios'
    : data.nombreCodigoDocumento || data.nombreCuenta
  const getPersistedAmount = item => getConciliationAdjustmentDisplay(item)
    ? getConciliationBalanceAmount(item, toArr(data.linkage)) : getItemAmountForSum(item, false)
  const linkedRows = toArr(data.linkage)
  const findLinkedRow = item => linkedRows.find(linked =>
    String(getRowId(linked)) === String(getRowId(item)))
  const auxiliary = esDin && conciliarConAnticipo ? null : data?.auxiliar ?? data?.deuda?.auxiliar
  const hasAuxiliary = auxiliary != null && String(auxiliary).trim() !== '' && Number.isFinite(Number(auxiliary))
  const balanceLinkedRows = getConciliationBalanceRows(linkedRows)
  const replacedRows = balanceLinkedRows.filter(item => isRowUnselected(item) || editedAmounts[getRowId(item)] != null)
  const removedAmount = replacedRows.reduce((sum, item) => sum + getPersistedAmount(item), 0)
  const removedAdjustment = getRemovedConciliationAdjustment(linkedRows, selectedRowsToSum, montoBaseDocumento)
  const pendingBeforeSelection = hasAuxiliary
    ? Math.max(Number(auxiliary) + removedAmount + removedAdjustment, 0)
    : Math.max(montoBaseDocumento - balanceLinkedRows.filter(item => !replacedRows.includes(item))
      .reduce((sum, item) => sum + getPersistedAmount(item), 0), 0)
  const allocation = allocateConciliationMovements(pendingBeforeSelection,
    selectedRowsToSum.filter(item => !findLinkedRow(item) || editedAmounts[getRowId(item)] != null).map(item => ({
      key: getConciliationRenderKey(item),
      available: editedAmounts[getRowId(item)] ?? (item.auxiliar != null && Number.isFinite(Number(item.auxiliar))
        ? item.auxiliar : getItemAmountForSum(item))
    })))
  const difference = allocation.pending - allocation.remaining
  const settledAmount = Math.max(montoBaseDocumento - allocation.pending, 0)
  const montoLiquidoBoleta = data.montoNetoLiquido ?? data.montoNeto
  const retencionBoleta = data.montoIvaRetenido ?? data.montoIva
  const obtenerAbreviatura = nombre => {
    return translations.documentosContables[nombre] || nombre
  }
  
  const isValidDate = (value) => {
  const date = new Date(value)
  return value && !isNaN(date.getTime())
}

  return (
    <ResizableModal
      open={open}
      onClose={handleClose}
      size="large" 
      footer={
        <>
          <Button
            onClick={handleClose}
            className='text-[10px] bg-primary text-white rounded-full'
            title='Cerrar'
          />
          <Button
            className='text-[10px] bg-accent2 text-white rounded-full'
            title='Guardar Conciliación'
            onClick={() => {
              const onlyUnlinking = selectedRowsToSum.length === 0 &&
                Object.values(unselectedIds).some(ids => ids.length > 0)
              if (onlyUnlinking) {
                handleFourInOne()
                return
              }
              const montoPorSaldar = difference

              if (montoPorSaldar > 0) {
                setPopupMessage( 'El monto conciliado es inferior al saldo pendiente.' )
                setShowConfirmPopup(true)
              } else if (montoPorSaldar < 0) {
                setPopupMessage( 'El monto conciliado supera el saldo pendiente.' )
                setShowConfirmPopup(true)
              } else {
                handleFourInOne()
              }
            }}
          />
        </>
      }
    >
      <>
        {processMessage && (
          <div className='flex items-center gap-2 text-xs text-accent2 mb-2'>
            <span className='h-3 w-3 border-2 border-accent2 border-t-transparent rounded-full animate-spin'></span>
            <span>{processMessage}</span>
          </div>
        )}
        {loading ? (
          <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
            <Lottie animationData={LoaderMain} loop autoplay style={{ width: 100, height: 100 }} />
          </Box>
        ) : (
          <>
            <div className='flex w-full h-full gap-4'>
              {/* LISTA IZQUIERDA */}
              <div className="flex-1 h-full w-[65%]">
                <ListEditVincular
                  type={type}
                  idLibro={idLibro}
                  idPrincipal={data.idPrincipal}
                  dataLinkage={data.linkage}
                  setReloadData={setReloadData}
                  reloadData={reloadData}
                  montoFilter={montoFilter}
                  aux={data.auxiliar}
                  selectedIds={selectedIds}
                  setSelectedIds={setSelectedIds}
                  setInitialSelectedIds={setInitialSelectedIds}
                  dataModal={data}
                  modalStatus={status}
                  unselectedIds={unselectedIds}
                  setUnselectedIds={setUnselectedIds}
                  onCurrentDataBanco={handleCurrentData('banco')}
                  onCurrentDataCaja={() => handleCurrentData('caja')}
                  onCurrentDataGestion={() => handleCurrentData('gestion')}
                  onCurrentDataTC={(rows, origin = 'tc') => handleCurrentData(origin)(rows)}
                  onCurrentDataNC={handleCurrentData('NC')}
                  selectedBank={selectedBank}
                  setSelectedBank={setSelectedBank}
                  origenSeleccionado={origenSeleccionado}
                  setOrigenSeleccionado={setOrigenSeleccionado}
                  selectedCheckboxes={selectedCheckboxes}
                  setSelectedCheckboxes={setSelectedCheckboxes}
                  selectedDataByOrigen={selectedDataByOrigen}
                  setSelectedDataByOrigen={setSelectedDataByOrigen}
                  getRowId={getRowId}
                  isInteracting={isInteracting}
                  setIsInteracting={setIsInteracting}
                  esDin={esDin}
                  conciliarConAnticipo={conciliarConAnticipo}
                  setConciliarConAnticipo={setConciliarConAnticipo}
                />
              </div>

              {/* PANEL DERECHO */}
              <div className='flex flex-col w-[35%] h-full font-medium'>
                {/* BLOQUE SUPERIOR */}
                

                {/* BLOQUE INFERIOR - CÁLCULO */}
                <div className='flex-1 flex flex-col bg-white rounded-3xl shadow-lg p-2 text-[11px] overflow-auto'>
                  {/* Documento principal */}
                  <div className='flex justify-between items-start mb-1'>
                    <div className='flex gap-2'>
                      <img className='w-5 h-5 mt-1' src={isologo_SII} alt='' />
                      <div className='flex flex-col'>
                        <p className='text-[12px] font-bold uppercase leading-5'>
                          {tituloDocumento} {data.codigoDocumento && ` (${data.codigoDocumento})`}
                        </p>
                        <p className='text-[12px] font-semibold uppercase leading-tight'>
                          Folio {data.folio}
                        </p>
                        <div className='flex items-center gap-1 text-[13px] leading-tight'>
                          <span>{formatDate(data.fecha)}</span>
                        </div>
                      </div>
                    </div>
                    <div className='flex flex-col items-end text-right text-[12px] min-w-[110px] whitespace-nowrap'>
                      <span className='text-accent3'>{data.status ?? status}</span>
                      {esBoleta ? (
                        <>
                          <p className='text-[13px] font-semibold leading-tight'>
                            {formatCurrency(montoLiquidoBoleta)}
                          </p>
                          <p className='text-[13px] text-accent3 leading-tight text-muted'>
                            Retención: {formatCurrency(retencionBoleta)}
                          </p>
                          <p className='text-[13px] text-gray-500 leading-tight text-muted'>
                            Total Honorario: {formatCurrency(data.montoTotal)}
                          </p>
                        </>
                      ) : esDin ? (
                        <>
                          <p className='text-[13px] font-semibold leading-tight'>
                            IVA: {formatCurrency(data.montoIva)}
                          </p>
                          <p className='text-[13px] leading-tight text-muted'>
                            Monto total: {formatCurrency(data.montoTotal)}
                          </p>
                          <p className='text-[13px] leading-tight text-muted'>
                            Neto: {formatCurrency(data.montoNeto)}
                          </p>
                        </>
                      ) : (
                        <>
                          <p className='text-[13px] font-semibold leading-tight'>
                            {formatCurrency(data.montoTotal)}
                          </p>
                          <p className='text-[13px] leading-tight text-muted'>
                            IVA: {formatCurrency(data.montoIva)}
                          </p>
                          {type !== 'honorario' && data.montoNeto !== 0 && (
                            <p className='text-[13px] leading-tight text-muted'>
                              Neto: {formatCurrency(data.montoNeto)}
                            </p>
                          )}
                          {data.montoExento !== 0 && (
                            <p className='text-[13px] leading-tight text-muted'>
                              Exento: {formatCurrency(data.montoExento)}
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  <div className='text-[12px] flex flex-col gap-0.5 border-b pb-1 mb-2'>
                    <p className='font-bold uppercase leading-tight'>{data.razonSocial}</p>
                    <div className='flex justify-between items-center'>
                      <p className='leading-tight'>{formatRut(data.rut)}</p>
                    </div>
                  </div>

                  {/* Filas de linkage/selectedRows */}
                  <div className='flex-1 overflow-auto font-medium'>
                    {rowsToShow.map((item) => {
                      const key = getConciliationRenderKey(item);
                      const tableId = getRowId(item)
                      const rowId = tableId
                      const rowUnlinkId = getRealConciliationId(item)
                      const isPreviousYearRow =
                        isPreviousYearConciliationLinkage(item) ||
                        item?._origen === 'gestion' ||
                        item?.tipo === 'gestion' ||
                        !isValidDate(item?.fecha)
                      const pendingUnlinkId = isPreviousYearRow
                        ? toNumId(item?.idPrincipal) ?? 0
                        : rowUnlinkId
                      const isExplicitlyUnselected = Object.values(unselectedIds || {})
                        .flat()
                        .some(id =>
                          [pendingUnlinkId, rowId, rowUnlinkId]
                            .filter(value => value != null)
                            .some(value => String(id) === String(value))
                        )
                      const checkboxKey = String(rowId)
                      const checkboxKeys = Array.from(
                        new Set(
                          [checkboxKey, item?.id, item?.idPrincipal, item?.realId]
                            .filter(
                              value =>
                                value != null &&
                                String(value).trim() !== '' &&
                                Number(value) !== 0
                            )
                            .map(String)
                        )
                      )
                      const explicitCheckboxKey = checkboxKeys.find(key =>
                        Object.prototype.hasOwnProperty.call(selectedCheckboxes, key)
                      )
                      const hasExplicitCheckboxState = explicitCheckboxKey != null
                      const isRowChecked = hasExplicitCheckboxState
                        ? selectedCheckboxes[explicitCheckboxKey] === true
                        : uniqueSelectedRowsData.some(
                            selectedRow => String(getRowId(selectedRow)) === String(rowId)
                          ) ||
                          toArr(data?.linkage).some(
                            linkedItem => String(getRowId(linkedItem)) === String(rowId)
                          )
                      return (
                      <div key={key}  className='flex justify-between items-center text-gray-700 py-1 border-b last:border-0'  >
                        <div className='flex items-center gap-4'>
                        <input
                        type="checkbox"
                        className="rounded"
                        checked={
                          !isExplicitlyUnselected &&
                          isRowChecked
                        }
                        onChange={(e) => {
                            setIsInteracting(true);
                            const checked = e.target.checked;
                            const tableId = getRowId(item) ?? item.id;
                            const isSaldoAnioAnterior = isPreviousYearRow
                            const rowOrigen = isSaldoAnioAnterior
                              ? 'gestion'
                              : item._origen || item.tipo || origenSeleccionado[0];

                            setSelectedDataByOrigen((prev) => {
                              const next = { ...prev };
                              if (checked) {
                                  const raw = next[rowOrigen];
                                  const arr = Array.isArray(raw) ? raw : [];
                                  if (!arr.some((r) => (r.id ?? getRowId(r)) === tableId)) {
                                      next[rowOrigen] = [...arr, ensureRowMetadata(item, rowOrigen)];
                                  }
                              } else {
                                  for (const k of Object.keys(next)) {
                                      const raw = next[k];
                                      const arr = Array.isArray(raw) ? raw : [];
                                      next[k] = arr.filter(
                                          (r) => getRowId(r) !== rowId
                                      );
                                  }
                              }
                              return next;
                            });

                            setSelectedIds((prev) => {
                              const next = { ...prev };
                              if (checked) {
                                const raw = next[rowOrigen];
                                const arr = Array.isArray(raw) ? raw : [];
                                next[rowOrigen] = [...arr, tableId];
                              } else {
                                  for (const k of Object.keys(next)) {
                                    const raw = next[k];
                                    const arr = Array.isArray(raw) ? raw : [];
                                    next[k] = arr.filter((id) => id !== tableId);
                                  }
                              }
                              return next;
                            })
                            setSelectedCheckboxes((prev) => {
                              const next = { ...prev }
                              ;[tableId, item?.id, item?.idPrincipal, item?.realId]
                                .filter(
                                  value =>
                                    value != null &&
                                    String(value).trim() !== '' &&
                                    Number(value) !== 0
                                )
                                .forEach(value => {
                                  next[String(value)] = checked
                                })
                              return next
                            });

                            const linkageIdPrincipal = toNumId(item?.idPrincipal)
                            const realId = linkageIdPrincipal ?? (
                              isSaldoAnioAnterior ? 0 : toNumId(rowId) ?? rowId
                            )
                            setUnselectedIds((prev) => {
                                const next = { ...prev };
                                const raw = next[rowOrigen];
                                const arr = Array.isArray(raw) ? raw : [];
                                if (checked) {
                                  next[rowOrigen] = arr.filter(
                                    id => String(id) !== String(realId)
                                  );
                                } else if (
                                  realId != null &&
                                  !arr.some(id => String(id) === String(realId))
                                ) {
                                  next[rowOrigen] = [...arr, realId];
                                }
                                return next;
                            });
                          }}
                        />
                          {item.nombreFolio ? (
                            <img src={isologo_SII} alt='SII' className='w-8 h-5' />
                          ) : (
                            <img
                              src={
                                bankIcons[item.nombreCuentaBanco]?.trim?.()
                                  ? bankIcons[item.nombreCuentaBanco]
                                  : imgDefaultBank 
                              }
                              alt={item.nombreCuentaBanco || 'Banco'}
                              className='w-8 h-8'
                            />
                          )}
                          <div className='flex flex-col leading-tight'>
                            <span>
                              {item.nombreCuentaBanco || obtenerAbreviatura(item.nombreFolio || item.nombreCuenta)}
                            </span>
                            <span>{getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco || item.numeroFolio)}</span>
                          </div>
                          <span>{getDisplayDescription(item)}</span>
                          <span>
                            {isPreviousYearConciliationLinkage(item) || item?._origen === 'gestion'
                              ? 'Saldado año anterior'
                              : isValidDate(item.fecha)
                                ? formatDate(item.fecha)
                                : 'Saldado año anterior'}
                          </span>
                        </div>

                        {/* LADO DERECHO */}
                        <div className='flex items-center'>
                          {(() => {
                            if (getConciliationAdjustmentDisplay(item)) return <ConciliationAdjustmentAmount movement={item} documentTotal={montoBaseDocumento} formatCurrency={formatCurrency} />
                            const isCajaItem =
                              item?._origen === 'caja' ||
                              item?.tipo === 'caja' ||
                              item?.nombreCuentaBanco?.toLowerCase?.().includes('caja')
                            const isGestionItem =
                              item?._origen === 'gestion' ||
                              item?.customRow === true ||
                              item?.tipo === 'gestion'

                            if (!isCajaItem && !isGestionItem) {
                              const assignedMovement = allocation.allocations.find(row =>
                                row.key === getConciliationRenderKey(item))
                              const linked = findLinkedRow(item)
                              const originalRow = Object.values(selectedDataByOrigen).flat().find(row =>
                                String(getRowId(row)) === String(getRowId(item))) ?? item
                              const originalAmount = getVinculacionAvailableAmount(originalRow)
                              const displayedAmount = editedAmounts[getRowId(item)] ??
                                assignedMovement?.available ?? (linked ? getPersistedAmount(linked) : getBancoAmount(item))
                              return (
                                <div className='flex flex-col text-right min-w-[120px] gap-1'>
                                  <span className='font-sans text-gray-400'>Disponible Asignado</span>
                                  {['banco', 'tc'].includes(item._origen || item.tipo || 'banco') ? <AssignedAmountInput
                                    aria-label={`Monto seleccionado ${getRowId(item)}`}
                                    className='border rounded-full text-xs text-right px-2 py-1 w-28 font-sans self-end'
                                    value={displayedAmount}
                                    min={1}
                                    max={originalAmount}
                                    onCommit={value => {
                                      const amount = Number(value)
                                      if (amount <= 0 || amount > originalAmount) return
                                      const baseline = linked ? getPersistedAmount(linked) :
                                        (item.auxiliar ?? getItemAmountForSum(item, false))
                                      setEditedAmounts(previous => {
                                        const next = { ...previous }
                                        if (amount === Number(baseline)) delete next[getRowId(item)]
                                        else next[getRowId(item)] = amount
                                        return next
                                      })
                                      setIsInteracting(true)
                                    }}
                                  /> : <span>{formatCurrency(displayedAmount)}</span>}
                                  {/*<span className='font-sans text-gray-400'>Monto original: {formatCurrency(originalAmount)}</span>*/}
                                </div>
                              )
                            }

                            const origen =
                              item._origen || (isCajaItem ? 'caja' : isGestionItem ? 'gestion' : null)
                            const rowId = getRowId(item)
                            const currentRows = selectedDataByOrigen[origen] || []
                            const selectedItem = currentRows.find(r => getRowId(r) === rowId)
                            const isEditableMonto =
                              (selectedItem?.customRow ?? item?.customRow) === true

                            if (!isEditableMonto) {
                              return (
                                <span className='text-right w-20'>
                                  {formatCurrency(
                                    selectedItem?.monto ??
                                      item?.monto ??
                                      selectedItem?.montoEditable ??
                                      item?.montoEditable ??
                                      item?.montoAbono ??
                                      item?.montoCargo ??
                                      item?.montoRelacionado ??
                                      item?.montoTotal ??
                                      item?.monto ??
                                      item?.debe ??
                                      item?.haber ??
                                      0
                                  )}
                                </span>
                              )
                            }

                            const montoValue =
                              selectedItem?.montoEditable ??
                              item?.montoEditable ??
                              item?.montoAbono ??
                              item?.montoCargo ??
                              item?.montoRelacionado ??
                              item?.montoTotal ??
                              item?.monto ??
                              item?.debe ??
                              item?.haber ??
                              0

                            return (
                              <input
                                key={`${origen}-${rowId}`}
                                type='text'
                                inputMode='numeric'
                                className='border rounded-full text-xs text-right px-1 py-0.5 w-20
                                [appearance:textfield]
                                [&::-webkit-outer-spin-button]:appearance-none
                                [&::-webkit-inner-spin-button]:appearance-none'
                                value={`$ ${Number(montoValue).toLocaleString('es-CL')}`}
                                onFocus={e => {
                                  e.target.value = montoValue.toString()
                                }}
                                onBlur={e => {
                                  const raw = e.target.value.replace(/[^\d]/g, '')
                                  e.target.value = `$ ${Number(raw || 0).toLocaleString('es-CL')}`
                                }}
                                onChange={e => {
                                  setIsInteracting(true)
                                  const digits = e.target.value.replace(/[^\d]/g, '')
                                  const newValue = Number(digits || 0)
                                  setSelectedDataByOrigen(prev => {
                                    const clonedPrev = structuredClone(prev)
                                    const current = clonedPrev[origen] || []
                                    const updated = current.map(r =>
                                      getRowId(r) === rowId ? { ...r, montoEditable: newValue } : r
                                    )
                                    return { ...clonedPrev, [origen]: updated }
                                  })
                                }}
                              />
                            )
                          })()}
                        </div>
                      </div>
                    )})}
                  </div>

                  {/* Sumatoria */}
                  <div className='flex justify-between border-t text-sm font-semibold mt-2 pt-1 shrink-0'>
                    <span>Monto Saldado</span>
                    <span>
                      {' '}
                      {formatCurrency(
                        settledAmount
                      )}
                    </span>
                  </div>

                  {/* Saldo por cobrar */}
                  <div className='flex justify-between mt-1 text-sm font-semibold text-accent2 shrink-0'>
                    <span>Diferencia</span>
                    <span>
                      {' '}
                      {formatCurrency(
                        difference
                      )}{' '}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
      <ConfirmConciliationModal
        difference={difference}
        onGenerateAdjustment={ajuste => {
          setShowConfirmPopup(false)
          handleFourInOne(ajuste)
        }}
        open={showConfirmPopup}
        message={popupMessage}
        onClose={() => setShowConfirmPopup(false)}
        actions={[
          { id: 'back', title: 'Volver', onClick: () => setShowConfirmPopup(false) },
          {
            id: 'save',
            title: 'Guardar',
            className: 'rounded-full bg-accent2 px-5 text-sm text-white',
            onClick: () => {
              setShowConfirmPopup(false)
              handleFourInOne()
            }
          }
        ]}
      />
    </ResizableModal>
  )
}

export default ModalEditConciliar
